var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kayipBg flex align-center justify-center"},[_c('div',{staticClass:"disDivAyar"},[_c('div',{staticClass:"ortayaCek"},[_c('div',{staticClass:"yaziYaz"},[_vm._v(" 404 - Not Found ")])]),_c('a',{staticClass:"anaSayfaGit",attrs:{"href":"./"}},[_c('i',{staticClass:"mdi mdi-home"}),_vm._v(" Anasayfa ")])])])
}]

export { render, staticRenderFns }